<!--
 * @Description: 首页/密码修改
 * @Author: yingbin
 * @Date: 2019-08-27 17:29:49
 * @LastEditTime: 2019-09-09 18:19:25
 * @LastEditors: yingbin
 -->
<template>
  <div class="updatePswd">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="旧密码：" prop="oldPass">
        <el-input
          minlength="6"
          maxlength="16"
          type="password"
          v-model="ruleForm.oldPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="pass">
        <el-input
          minlength="6"
          maxlength="16"
          type="password"
          v-model="ruleForm.pass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="checkPass">
        <el-input
          minlength="6"
          maxlength="16"
          type="password"
          v-model="ruleForm.checkPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="confirmUpdate('ruleForm')">确认修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import user from "../../apis/user_apis";
import { updatePswdRules } from "../../validate/rules";
export default {
  data() {
    return {
      ruleForm: {
        pass: "",
        checkPass: "",
        oldPass: ""
      },
      rules: updatePswdRules
    };
  },
  mounted() {},
  methods: {
    confirmUpdate() {
      let that = this;
      that.name = this.$store.state.userInfo;
      that.$refs.ruleForm.validate(valid => {
        if (valid) {
          user.rewritePswd(that).then(res => {
            console.log(res);
            if (res.success) {
              this.$emit("func", { title: "账号信息" });
              sessionStorage.setItem("title", "账号信息");
              this.$router.push({
                path: "/account/userInfo"
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.updatePswd {
  padding-top: 64px;
  padding-left: 180px;
  /deep/ .el-form-item__content {
    width: 280px;
  }
  /deep/ .el-button {
    width: 280px;
    height: 50px;
    font-size: 18px;
    margin-top: 10px;
    background: #43425d;
    border: 1px solid #43425d;
    color: #fff;
  }
}
</style>